import React, { memo } from "react";
import { Grid } from "@mui/material";

import RRDDirectDistributionToggleInput from "../common/rrdInputFields/RRDDirectDistributionToggleInput";
import RRDDirectDistributionCostInput from "../common/rrdInputFields/RRDDirectDistributionCostInput";
import RRDDirectDistributionQntInput from "../common/rrdInputFields/RRDDirectDistributionQntInput";

type RRDLocationDistributionCostProps = {
  locationId: string | number;
  distributionCostAdmin?: number;
};

function RRDLocationDistributionCost({
  locationId,
  distributionCostAdmin,
}: RRDLocationDistributionCostProps) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <RRDDirectDistributionToggleInput
          name={`${locationId}.distribution`}
          storeCopyToggleName={`${locationId}.store_copy`}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <RRDDirectDistributionQntInput
          name={`${locationId}.estimated_distribution`}
          distributionToggleName={`${locationId}.distribution`}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <RRDDirectDistributionCostInput
          name={`${locationId}.distribution_cost`}
          distributionToggleName={`${locationId}.distribution`}
          distributionCostAdmin={distributionCostAdmin}
        />
      </Grid>
    </Grid>
  );
}

export default memo(RRDLocationDistributionCost);
